export async function sendFormData(url: string, data: any, returnsText = false) {
    const formData = new FormData();
    for (const name in data) {
        formData.append(name, data[name]);
    }

    const response = await fetch(url, {
        method: 'POST',
        body: formData, // The browser automatically sets the correct Content-Type
    });
    if (!response.ok) {
        const message = await response.text();
        throw new Error(message);
    }

    return returnsText ? response.text() : response.json();
}
export async function sendBodyData(url: string, data: any, returnsText = false) {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert the object to a JSON string
    });
    if (!response.ok) {
        const message = await response.text();
        throw new Error(message);
    }
    return returnsText ? response.text() : response.json();
}

export async function fetchJson(url: string, returnsText = false) {
    const response = await fetch(url, {
        method: 'GET',
        cache: 'no-store',
    });
    if (!response.ok) {
        const message = await response.text();
        throw new Error(message);
    }
    return returnsText ? response.text() : response.json();
}
